import styled, { css } from 'styled-components'

const ModelButton = styled.button`
  ${({ theme }) => css`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(3)};
    padding: ${theme.spacing(3)} ${theme.spacing(4)};
    background-color: white;
    border: 0.1rem solid ${theme.palette.grey[300]};
    border-radius: ${theme.spacing(0.25)};

    ${theme.media('xs')} {
      flex-direction: row;
      justify-content: space-between;
    }

    ${theme.media('sm')} {
      flex-direction: column;
    }

    img {
      max-height: 21.4rem;
      width: auto;

      ${theme.media('xs')} {
        order: 1;
      }

      ${theme.media('sm')} {
        order: 0;
      }
    }

    span {
      font-size: 1.8rem;
    }

    &:hover {
      box-shadow: 0 0 0 0.2rem ${theme.palette.grey[300]};
    }
  `}
`

export default {
  ModelButton,
}
